/* eslint-disable @typescript-eslint/no-explicit-any */
import { UseClientModelContext } from '@mercadoni/sinister/dist/cjs/client/contexts'
import { useInteraction } from '@mercadoni/sinister/dist/cjs/monitors/hooks'
import { trackEvent } from '@mercadoni/sinister/dist/cjs/monitors/services'

import styled from 'styled-components'
import Link from '../../atomic/Link'
import Icon from './Icon'
import Text from './Text'

const StyledHelperLink = styled(Link)`
  display: flex;
  padding: 20px;
  align-items: center;
  font-weight: var(--typography-weight-bold);
`

const HelperLinkLogic = ({
  Wrapper,
  href,
  target,
  icon,
  text,
}: {
  Wrapper: any
  href: string
  target: string
  icon: string
  text: string
}) => {
  const { sendInteractionEvent } = useInteraction()
  const { clientId } = UseClientModelContext()

  const onClick = () => {
    trackEvent({
      eventName: 'header_help_items',
      clientId,
      customParams: { href, source: 'mobile' },
    })
    sendInteractionEvent({ interactionName: text })
  }

  return (
    <Wrapper href={href} target={target} onClick={onClick}>
      <Icon icon={icon} onClick={onClick} />
      <Text text={text} />
    </Wrapper>
  )
}

const HelperLink = ({
  href,
  target,
  icon,
  text,
}: {
  href: string
  target: string
  icon: string
  text: string
}) => (
  <HelperLinkLogic
    Wrapper={StyledHelperLink}
    href={href}
    target={target}
    icon={icon}
    text={text}
  />
)

export default HelperLink
